import { gql } from '@apollo/client'
import { OwnerFragment } from '@src/graphql/fragment/account'
import { ListingInfoFragment } from '@src/graphql/fragment/listingInfo'

export const ApostleSkillFragment = gql`
  fragment ApostleSkill on SkillEXPInfo {
    key
    level
    skillID
  }
`

export const ApostleLiteFragment = gql`
  fragment ApostleLite on Apostle {
    apostleID
    class
    image
    iv
    metaKey
    nftListingStatus
    reforgeCount
    ticketMint
    skills {
      ...ApostleSkill
    }
    name
    status
    listingInfo {
      ...ListingInfo
    }
  }
  ${ApostleSkillFragment}
  ${ListingInfoFragment}
`

export const ApostleFragment = gql`
  fragment Apostle on Apostle {
    ...ApostleLite
    name
    nftListingStatus
    reforgeCount
    owner {
      ...Owner
    }
  }
  ${ApostleLiteFragment}
  ${OwnerFragment}
`

export const ApostleCommonFragment = gql`
  fragment ApostleCommon on ApostleCommon {
    head
    cloth
    weapon
    iv
    classType
    metaKey
    skills {
      ...ApostleSkill
    }
    image
    createdAt
  }
  ${ApostleSkillFragment}
`
